import Link from "@/components/common/Link";
import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";

export default function FeaturesHomeOne() {
  const { messages } = useI18n();
  const features = messages.features;
  const section = features.section;
  const transport = features.transport;
  const oils = features.oils;
  const parts = features.parts;
  const common = messages.common;

  return (
    <section className="features-section">
      {/* <!-- Divider --> */}
      <div className="divider"></div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 col-xxl-6">
            <div className="section-heading text-center">
              <span className="subtitle">{section.subtitle}</span>
              <h2 className="mb-4">{section.title}</h2>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Divider --> */}
      <div className="divider-sm"></div>
      <div className="container">
        <div className="row g-5 align-items-center">
          {/* <!-- Featured Image --> */}
          <div className="col-12 col-md-6">
            <div className="featured-img translateY10 me-xl-4">
              <Image className="tilt-image img-anim-left w-auto h-auto" src="/assets/img/bg-img/truck-transporting-cars-2025-03-10-04-23-19-utc.jpg" alt="استيراد وسائل النقل - شاحنات ومركبات تجارية من شركة البراق الدولية" width={800} height={800} priority/>
            </div>
          </div>
          {/* <!-- Featured Content --> */}
          <div className="col-12 col-md-6">
            <div className="featured-content">
              <h2 className="mb-3">{transport.title}</h2>
              <p className="mb-4">{transport.description}</p>

              {/* <!-- List --> */}
              <ul className="list-unstyled mb-5 featured-list">
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {transport.list.item1}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {transport.list.item2}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {transport.list.item3}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {transport.list.item4}
                </li>
              </ul>
              {/* <!-- Button --> */}
              <Link href="/services" className="btn btn-primary">
                <span>{common.readMore} <i className="ti ti-arrow-up-right"></i></span>
                <span>{common.readMore} <i className="ti ti-arrow-up-right"></i></span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="row g-5 align-items-center">
          {/* <!-- Featured Content --> */}
          <div className="col-12 col-md-6">
            <div className="featured-content">
              <h2 className="mb-3">{oils.title}</h2>
              <p className="mb-4">{oils.description}</p>
              {/* <!-- List --> */}
              <ul className="list-unstyled mb-5 featured-list">
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {oils.list.item1}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {oils.list.item2}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {oils.list.item3}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {oils.list.item4}
                </li>
              </ul>
              {/* <!-- Button --> */}
              <Link href="/services" className="btn btn-primary">
                <span>{common.readMore} <i className="ti ti-arrow-up-right"></i></span>
                <span>{common.readMore} <i className="ti ti-arrow-up-right"></i></span>
              </Link>
            </div>
          </div>

          {/* <!-- Featured Image --> */}
          <div className="col-12 col-md-6">
            <div className="featured-img translateY10 me-xl-4">
              <Image className="tilt-image img-anim-right w-auto h-auto" src="/assets/img/bg-img/beautiful-still-life-with-water.jpg" alt="استيراد الزيوت والبطاريات - زيوت محركات وبطاريات سيارات من شركة البراق الدولية" width={800} height={800} priority/>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="row g-5 align-items-center">
          {/* <!-- Featured Image --> */}
          <div className="col-12 col-md-6">
            <div className="featured-img translateY10 me-xl-4">
              <Image className="tilt-image img-anim-left w-auto h-auto" src="/assets/img/bg-img/close-up-of-new-car-parts-on-black-background-2025-02-25-20-03-39-utc.jpg" alt="قطع الغيار والإطارات - قطع غيار أصلية وإطارات سيارات من شركة البراق الدولية" width={800} height={800} priority/>
            </div>
          </div>

          {/* <!-- Featured Content --> */}
          <div className="col-12 col-md-6">
            <div className="featured-content">
              <h2 className="mb-3">{parts.title}</h2>
              <p className="mb-4">{parts.description}</p>
              {/* <!-- List --> */}
              <ul className="list-unstyled mb-5 featured-list">
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {parts.list.item1}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {parts.list.item2}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {parts.list.item3}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon2"></use>
                  </svg> {parts.list.item4}
                </li>
              </ul>
              {/* <!-- Button --> */}
              <Link href="/services" className="btn btn-primary">
                <span>{common.readMore} <i className="ti ti-arrow-up-right"></i></span>
                <span>{common.readMore} <i className="ti ti-arrow-up-right"></i></span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>
    </section>
  )
}
